import React, { useEffect } from 'react';
import styled from 'styled-components';
import { LipscoreReviewsInterface } from './types/LipscoreProductModel.types';

const StyledLipscoreReviews = styled.div`
  font-size: 1rem;
  width: 100%;
  
  .lipscore-real-reviews-badge-container {
    display: none;
  }
`;

const LipscoreReviews = ({productModel, readOnly}: LipscoreReviewsInterface) => {
  useEffect(() => {
    globalThis.lipscore && globalThis.lipscore.reInitWidgets();
  }, []);

  return (
    <StyledLipscoreReviews>
      <div id='lipscore-review-list'
        data-ls-product-id={productModel.productId}
        data-ls-product-name={productModel.name}
        data-ls-product-brand={productModel.brand}
        data-ls-product-url={productModel.productUrl}
        data-ls-product-image={productModel.imageUrl}
        data-ls-product-description={productModel.description}
        data-ls-product-price={productModel.price}
        data-ls-product-currency={productModel.currency}
        data-ls-product-availability={productModel.inStock}
        data-ls-product-category={productModel.category}
        data-ls-product-gtin={productModel.gtin}
        data-ls-readonly={readOnly ? 'true' : 'false'}></div>
    </StyledLipscoreReviews>
  );
};

export default LipscoreReviews;
